import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './Carousel.module.scss';
const Carousel = ({ items, autoplay = true, autoplaySpeed = 3000, dots = true, arrows = true, infinite = true, slidesToShow = 1, slidesToScroll = 1, responsive, className = '' }) => {
    const settings = {
        dots,
        infinite,
        speed: 500,
        slidesToShow,
        slidesToScroll,
        autoplay,
        autoplaySpeed,
        arrows,
        responsive: responsive || [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(slidesToShow, 2),
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (_jsx("div", { className: `${styles.carousel} ${className}`, children: _jsx(Slider, { ...settings, children: items.map((item) => (_jsx("div", { className: styles.slide, children: _jsxs("div", { className: styles.slideContent, children: [_jsx("img", { src: item.image, alt: item.title || 'Carousel image', className: styles.slideImage }), (item.title || item.description) && (_jsxs("div", { className: styles.slideOverlay, children: [item.title && _jsx("h3", { className: styles.slideTitle, children: item.title }), item.description && _jsx("p", { className: styles.slideDescription, children: item.description })] }))] }) }, item.id))) }) }));
};
export default Carousel;
